import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function OccurrenceTypeList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="OccurrenceType"
      toggleStatusRoute="OccurrenceType"
      requestName="OccurrenceType"
      route="/TipoOcorrencia"
      cdPage="id"
      btnNew={true}
    />
  );
}
